module.exports = __webpack_public_path__ + "assets/img/799297520174dde0ef8575adecb101d3.svg";